import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { Suspense } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import PulseLoader from 'react-spinners/PulseLoader';
import { UserProvider } from '../auth/UserProvider';
import { ApolloProvider } from '../components/common/Apollo';
import { AsyncTaskListProvider } from '../components/common/AsyncTaskList';
import { UserNamesProvider } from '../components/common/ChangeHistory';
import { CypressCoordinatesHelper } from '../components/common/Jore';
import { Toaster } from '../components/common/Toast/Toaster';
import { theme } from '../generated/theme';
import { ReduxProvider } from '../redux';
import { Router } from '../router/Router';
import { reactPlugin } from '../utils/applicationInsights';

const enableCypressCoordinateHelper = false;

const Index = () => {
  const { i18n } = useTranslation();

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <HelmetProvider>
        <Helmet>
          <html lang={i18n.language} />
          <title>JORE4 Testiversio</title>
          <link rel="icon" href="/favicon.ico" />
        </Helmet>
        <ApolloProvider>
          <ReduxProvider>
            <Suspense
              fallback={
                <PulseLoader
                  color={theme.colors.brand}
                  size={25}
                  cssOverride={{
                    display: 'inline-block',
                    position: 'relative',
                    paddingTop: '2rem',
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                  }}
                  speedMultiplier={0.7}
                />
              }
            >
              <UserProvider />
              <AsyncTaskListProvider>
                <UserNamesProvider>
                  <Router />
                </UserNamesProvider>
              </AsyncTaskListProvider>
              <Toaster />
            </Suspense>
          </ReduxProvider>
        </ApolloProvider>

        {enableCypressCoordinateHelper && <CypressCoordinatesHelper />}
      </HelmetProvider>
    </AppInsightsContext.Provider>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default Index;
